/**
 * Employee Web — `/me/profile/emergency` tab route (Plan 05.2-05).
 *
 * Single owner of the self-service emergency contacts (bulk-replace editor
 * + read-only medical card) inside the 6-tab shell.
 */
import type { JSX } from "react";
import { createFileRoute } from "@tanstack/react-router";
import { EmergencyTab } from "@linkhr/employee-self-service";

export const Route = createFileRoute("/_auth/me/profile/emergency")({
  staticData: { breadcrumb: { labelKey: "me-profile:tabs.emergency" } },
  component: EmergencyTabRoute,
});

function EmergencyTabRoute(): JSX.Element | null {
  return <EmergencyTab />;
}
